export default __webpack_public_path__ + "static/media/Icon-patient-name-new.a180b1bf.svg";